var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconedit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 15.2427C4 14.447 4.31607 13.684 4.87868 13.1214L13.8787 4.12136C15.0503 2.94978 16.9497 2.94978 18.1213 4.12135L19.8787 5.87871C21.0503 7.05029 21.0503 8.94978 19.8787 10.1214L10.8787 19.1214C10.3161 19.684 9.55301 20 8.75736 20H5C4.44772 20 4 19.5523 4 19V15.2427ZM15.3787 11.7929L9.46447 17.7071C9.27693 17.8947 9.02258 18 8.75736 18H6V15.2427C6 14.9775 6.10536 14.7231 6.29289 14.5356L12.2071 8.62134L15.3787 11.7929ZM16.7929 10.3787L18.4645 8.70714C18.855 8.31662 18.855 7.68345 18.4645 7.29293L16.7071 5.53557C16.3166 5.14505 15.6834 5.14504 15.2929 5.53557L13.6213 7.20712L16.7929 10.3787Z",
    fill: "#3B5118"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconedit);
export default __webpack_public_path__ + "static/media/icon.edit.0a9e22f1d8593ef188968a3b2ad978cd.svg";
export { ForwardRef as ReactComponent };